import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {Button, LegacyInput, SearchIcon} from '@edume/magnificent';

import styles from './styles.module.scss';

function SearchBar({
  isHeaderView,
  onChange,
  value,
  onModeChange,
  isModeSearch,
}) {
  return (
    <div
      styleName={classNames('search-bar', {
        'search-bar-header': isHeaderView,
      })}
    >
      <div styleName='search-bar-input'>
        <SearchIcon colour='grey300' size='small' />
        <LegacyInput
          placeholder='Search'
          type='text'
          width='fullWidth'
          onChangeValue={onChange}
          onFocus={() => onModeChange?.(true)}
          value={value}
          validationEmotes={false}
        />
      </div>
      {isModeSearch && (
        <Button
          buttonText='Cancel'
          innerContent='text'
          isCursorAllowed
          noBorder
          noMarginLeft
          noMarginTop
          onClick={() => {
            onModeChange?.(false);
          }}
          reskinClassName=''
          type='thirdary'
        >
          Cancel
        </Button>
      )}
    </div>
  );
}

SearchBar.propTypes = {
  isHeaderView: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onModeChange: PropTypes.func,
  isModeSearch: PropTypes.bool,
};

export default CSSModules(SearchBar, styles, {allowMultiple: true});
